module.exports = __webpack_public_path__ + "static/media/pdf.a3cb2733.svg";